import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'dva/router';

const Test = lazy(() => import('@pages/goods/test'));
const GoodsBrands = lazy(() => import('@pages/goods/brands'));
const GoodsCategory = lazy(() => import('@pages/goods/category'));
const GoodsService = lazy(() => import('@pages/goods/service'));
const GoodsActivity = lazy(() => import('@pages/goods/activity'));
const GoodsClass = lazy(() => import('@pages/goods/class'));
const GoodsMaterial = lazy(() => import('@pages/goods/material'));
const GoodsMaterialEdit = lazy(() => import('@pages/goods/material/material-edit'));
const GoodsList = lazy(() => import('@pages/goods/list'));
const GoodsExamination = lazy(() => import('@pages/goods/list/examination'));
const GoodsSpec = lazy(() => import('@pages/goods/spec'));
const GoodsTag = lazy(() => import('@pages/goods/tag'));
const GoodsTagView = lazy(() => import('@pages/goods/tag-view'));
const OldSystem = lazy(() => import('@pages/old-system'));
const Replenish = lazy(() => import('@pages/goods/replenish'));
const GoodsNoDeliver = lazy(() => import('@pages/goods/no-deliver'));
const GoodsSpecialFreight = lazy(() => import('@pages/goods/special-freight'));

// 分销
const AgentClear = lazy(() => import('@pages/distributor/agent-clear'));
const DistributorList = lazy(() => import('@pages/distributor/list'));
const DistributorDetail = lazy(() => import('@pages/distributor/detail'));
const DistributorLevel = lazy(() => import('@pages/distributor/level'));
const SettledGoods = lazy(() => import('@pages/distributor/settled-goods'));
const SettledGoodsDetail = lazy(() => import('@pages/distributor/settled-goods/detail'));
const DistributorProduct = lazy(() => import('@pages/distributor/product'));
const DistributorStatistical = lazy(() => import('@pages/distributor/statistical'));
const SettledOrder = lazy(() => import('@pages/distributor/settled-order'));
const DistributorUpgrade = lazy(() => import('@pages/distributor/upgrade'));

//会员
const MembersList = lazy(() => import('@pages/members/list'));
const MembersNotification = lazy(() => import('@pages/members/list/notification'));
const MembersBalance = lazy(() => import('@pages/members/balance'));
const MembersBalanceDetail = lazy(() => import('@pages/members/balance-detail'));
const MembersScore = lazy(() => import('@pages/members/score'));
const MembersMsgTemplate = lazy(() => import('@pages/members/msg-template'));
const MembersMsgTemplateRecord = lazy(() => import('@pages/members/msg-template/send-record'));

// 交易
const Evaluate = lazy(() => import('@pages/trading/evaluate'));
const Order = lazy(() => import('@pages/trading/order'));
const OrderLogs = lazy(() => import('@pages/trading/order-logs'));
const Refund = lazy(() => import('@pages/trading/refund'));
const RefundReason = lazy(() => import('@pages/trading/refunds-reason'));
const ReturnGoods = lazy(() => import('@pages/trading/return-goods'));
const ShipmentRemind = lazy(() => import('@pages/trading/shipment-remind'));
const Gift = lazy(() => import('@pages/trading/gift'));
const PaycodeSearch = lazy(() => import('@pages/trading/paycode-search'));
const PayCodeRefundList = lazy(() => import('@pages/trading/paycode-refund-list'));
const PayErrorList = lazy(() => import('@pages/trading/pay-error'));
const RefundFreight = lazy(() => import('@pages/trading/refund-freight'));
const RefundError = lazy(() => import('@pages/trading/refund-error'));

// 促销
const Seckill = lazy(() => import('@pages/promotion/seckill'));
const SeckillDetails = lazy(() => import('@pages/promotion/seckill/detail'));
const LogisticsCover = lazy(() => import('@pages/promotion/activities-cover'));
const LogisticsCoverEdit = lazy(() => import('@pages/promotion/activities-cover/edit'));
const GeneralHtml = lazy(() => import('@pages/promotion/activities-cover'));
const GeneralHtmlEdit = lazy(() => import('@pages/promotion/activities-cover/general-edit'));
const Relay = lazy(() => import('@pages/promotion/relay'));

// 运营
const Message = lazy(() => import('@pages/operation/message'));
const Docment = lazy(() => import('@pages/operation/docment'));
const Invite = lazy(() => import('@pages/operation/invite'));
const Lottery = lazy(() => import('@pages/operation/lottery'));
const GoodsSetting = lazy(() => import('@pages/operation/goods-setting'));
const SupportComplain = lazy(() => import('@pages/operation/support-complain'));
const SupportFeedback = lazy(() => import('@pages/operation/support-feedback'));
const Payment = lazy(() => import('@pages/operation/payment'));
const PaymentAccountList = lazy(() => import('@pages/operation/payment/account-list'));
const RefundCoupon = lazy(() => import('@pages/operation/refund-coupon'));
const Ads = lazy(() => import('@pages/operation/ads'));
const AdsEdit = lazy(() => import('@pages/operation/ads/edit'));
const AdsArea = lazy(() => import('@pages/operation/ads/area'));
const AdsSkip = lazy(() => import('@pages/operation/ads-skip'));
const AdsPosition = lazy(() => import('@pages/operation/ads-position'));
const AdsPositionEdit = lazy(() => import('@pages/operation/ads-position/edit'));
const AdsPosters = lazy(() => import('@pages/operation/posters'));
const Coupons = lazy(() => import('@pages/operation/coupons'));
const CouponsCreate = lazy(() => import('@pages/operation/coupons/create'));
const ComplainFeedBackList = lazy(() => import('@pages/operation/complain-feedback-list'));
const GiftActivity = lazy(() => import('@pages/operation/gift-activity'));
const GiftActivitySave = lazy(() => import('@pages/operation/gift-activity/save'));
const ExchangeActivity = lazy(() => import('@pages/operation/exchange-activity'));
const ExchangeActivitySave = lazy(() => import('@pages/operation/exchange-activity/save'));
const Skins = lazy(() => import('@pages/operation/skins'));
const SkinsSave = lazy(() => import('@pages/operation/skins/save'));
const DelayShipment = lazy(() => import('@pages/operation/delay-shipment'));
const DelayShipmentEdit = lazy(() => import('@pages/operation/delay-shipment/edit'));

// 社区
const Comments = lazy(() => import('@pages/community/comments'));
const CommunityWhiteList = lazy(() => import('@pages/community/white-list'));
const Posts = lazy(() => import('@pages/community/posts'));
const PostsEdit = lazy(() => import('@pages/community/posts/edit'));
const PostsOfficialEdit = lazy(() => import('@pages/community/posts/edit-official'));

const CommunityLevel = lazy(() => import('@pages/community/level'));
const CommunityUsers = lazy(() => import('@pages/community/users'));

//系统
const Purview = lazy(() => import('@pages/system/purview'));
const Organization = lazy(() => import('@pages/system/organization'));
const UserRoles = lazy(() => import('@pages/system/roles'));
const UserRolesEdit = lazy(() => import('@pages/system/roles/edit'));
const Workers = lazy(() => import('@pages/system/workers'));
const SystemLogs = lazy(() => import('@pages/system/logs'));
const AppVersions = lazy(() => import('@pages/system/app-versions'));
const AppVersionNew = lazy(() => import('@pages/system/app-version-new'));
const GrayTask = lazy(() => import('@pages/system/gray-test'));
const Redis = lazy(() => import('@pages/system/redis'));
const RedisPay = lazy(() => import('@pages/system/redis-pay'));
const RedisCart = lazy(() => import('@pages/system/redis-cart'));
const RedisCartPanel = lazy(() => import('@pages/system/redis-cart-panel'));
const RedisPanel = lazy(() => import('@pages/system/redis-panel'));
const RedisCache = lazy(() => import('@pages/system/redis-cache'));
const RedisCachePanel = lazy(() => import('@pages/system/redis-cache-panel'));
const CacheSearch = lazy(() => import('@pages/system/cache-search'));
const PaymentTree = lazy(() => import('@pages/system/payment/tree'));

//工单
const WorkingOrderList = lazy(() => import('@pages/working-orders/list'));
const WorkingOrderConfig = lazy(() => import('@pages/working-orders/orders-config'));
const WorkingOrderDetail = lazy(() => import('@pages/working-orders/list/detail'));

//统计
const AgentData = lazy(() => import('@pages/statistic/data-agents'));
const TopGoods = lazy(() => import('@pages/statistic/top-goods'));
const Integral = lazy(() => import('@pages/statistic/data-integral'));
const StatisticSeckill = lazy(() => import('@pages/statistic/seckill'));
const OrdersTimeOut = lazy(() => import('@pages/statistic/order-timeout'));
const Finance = lazy(() => import('@pages/statistic/finance'));
const FinancialReconciliation = lazy(() => import('@pages/statistic/financial-reconciliation'));
const YunJi = lazy(() => import('@pages/statistic/yun-ji'));
const StatisticRefund = lazy(() => import('@pages/statistic/data-refund'));

const DailyNew = lazy(() => import('@pages/statistic/daily-new'));

//官网
const WebNews = lazy(() => import('@pages/website/news'));
const WebNewsSave = lazy(() => import('@pages/website/news/edit'));
const Appliers = lazy(() => import('@pages/website/appliers'));
const BasicSetting = lazy(() => import('@pages/website/basic-setting'));

//基本
const BasicExpress = lazy(() => import('@pages/basic/express'));
const Keywords = lazy(() => import('@pages/basic/keywords'));
const Banks = lazy(() => import('@pages/basic/banks'));
const Account = lazy(() => import('@pages/basic/account'));
const Paying = lazy(() => import('@pages/basic/pay'));
const Setting = lazy(() => import('@pages/basic/setting'));
const SettingEdit = lazy(() => import('@pages/basic/setting/basic-edit'));
const SettingUEdit = lazy(() => import('@pages/basic/setting/basic-uedit'));

//基本
const Buyers = lazy(() => import('@pages/buyers/management'));
const BuyersGrade = lazy(() => import('@pages/buyers/grade'));
const LiveExam = lazy(() => import('@pages/live/questionnaire'));

//预约
const AppointmentWait = lazy(() => import('@pages/appointment/waiting'));
const AppointmentList = lazy(() => import('@pages/appointment/list'));
const AppointmentConfig = lazy(() => import('@pages/appointment/config'));
const AppointmentConfigEdit = lazy(() => import('@pages/appointment/config/address-config/edit'));

//预约
const DistrictInviteErrorMonitor = lazy(() => import('@pages/district-invite/error-monitor'));
const DistrictInviteRulesAll = lazy(() => import('@pages/district-invite/invite-rules-all'));
const DistrictInviteRules = lazy(() => import('@pages/district-invite/invite-rules'));

//KA
const KaBuyers = lazy(() => import('@pages/ka/ka-buyers'));
const KaYearManifest = lazy(() => import('@pages/ka/year-manifest'));
const KaLogs = lazy(() => import('@pages/ka/ka-logs'));
const KaConfig = lazy(() => import('@pages/ka/config'));

// 供应商
const SupplierList = lazy(() => import('@pages/supplier/list'));
const SupplierGoods = lazy(() => import('@pages/supplier/goods'));
const SupplierEntityList = lazy(() => import('@pages/supplier/entity-list'));

// 连连
const LianlianWithdrawList = lazy(() => import('@pages/lianlian/withdraw-list'));
const LianlianAccountList = lazy(() => import('@pages/lianlian/account-list'));
const LianlianEnterpriseList = lazy(() => import('@pages/lianlian/enterprise-list'));

// 支付宝批量打款
const AlipayRemitList = lazy(() => import('@pages/alipay-remit/list'));
const AlipayRemitCreate = lazy(() => import('@pages/alipay-remit/create'));

const Distributor = () => {
  return (
    <Switch>
      <Route exact path="/test" component={props => <Test {...props} />} />
      <Route exact path="/goods/brands" component={props => <GoodsBrands {...props} />} />
      <Route exact path="/goods/category" component={props => <GoodsCategory {...props} />} />
      <Route exact path="/goods/service" component={props => <GoodsService {...props} />} />
      <Route exact path="/goods/activity" component={props => <GoodsActivity {...props} />} />
      <Route exact path="/goods/class" component={props => <GoodsClass {...props} />} />
      <Route exact path="/goods/spec" component={props => <GoodsSpec {...props} />} />
      <Route exact path="/goods/list" component={props => <GoodsList {...props} />} />
      <Route exact path="/goods/examination/:id" component={props => <GoodsExamination {...props} />} />
      <Route exact path="/goods/tag" component={props => <GoodsTag {...props} />} />
      <Route exact path="/goods/tag-view/:id" component={props => <GoodsTagView {...props} />} />
      <Route exact path="/goods/no-deliver-area/:goods_basicid" component={props => <GoodsNoDeliver {...props} />} />
      <Route exact path="/goods/material/:id?" component={props => <GoodsMaterial {...props} />} />
      <Route exact path="/goods/replenish/:goodsBasicId?" component={props => <Replenish {...props} />} />
      <Route exact path="/goods/material-edit/:gid?/:mid?" component={props => <GoodsMaterialEdit {...props} />} />
      <Route exact path="/goods/special-freight" component={props => <GoodsSpecialFreight {...props} />} />

      <Route exact path="/old/system/:id" component={props => <OldSystem {...props} />} />

      {/* 分销 */}
      <Route exact path="/distributor/agent/clear" component={props => <AgentClear {...props} />} />
      <Route exact path="/distributor/list" component={props => <DistributorList {...props} />} />
      <Route exact path="/distributor/list/:shopId?/:memberId?" component={props => <DistributorDetail {...props} />} />
      <Route exact path="/distributor/level" component={props => <DistributorLevel {...props} />} />
      <Route exact path="/distributor/settled/goods" component={props => <SettledGoods {...props} />} />
      <Route exact path="/distributor/settled/goods/:id?" component={props => <SettledGoodsDetail {...props} />} />
      <Route exact path="/distributor/product" component={props => <DistributorProduct {...props} />} />
      <Route exact path="/distributor/statistical" component={props => <DistributorStatistical {...props} />} />
      <Route exact path="/distributor/settled/order" component={props => <SettledOrder {...props} />} />
      <Route exact path="/distributor/upgrade" component={props => <DistributorUpgrade {...props} />} />

      {/* 会员 */}
      <Route exact path="/members/list" component={props => <MembersList {...props} />} />
      <Route exact path="/members/balance/list" component={props => <MembersBalance {...props} />} />
      <Route exact path="/members/balance/detail" component={props => <MembersBalanceDetail {...props} />} />
      <Route exact path="/members/score" component={props => <MembersScore {...props} />} />
      <Route exact path="/members/notification" component={props => <MembersNotification {...props} />} />
      <Route exact path="/members/msg-template" component={props => <MembersMsgTemplate {...props} />} />
      <Route
        exact
        path="/members/msg-template/send-record/:template_id"
        component={props => <MembersMsgTemplateRecord {...props} />}
      />

      <Route exact path="/live/questionnaire" component={props => <LiveExam {...props} />} />

      {/* 交易 */}
      <Route exact path="/trading/evaluate" component={props => <Evaluate {...props} />} />
      <Route exact path="/trading/order/:member_id?" component={props => <Order {...props} />} />
      <Route exact path="/trading/order/logs" component={props => <OrderLogs {...props} />} />
      <Route exact path="/trading/refund" component={props => <Refund {...props} />} />
      <Route exact path="/trading/refund/reason" component={props => <RefundReason {...props} />} />
      <Route exact path="/trading/return/goods" component={props => <ReturnGoods {...props} />} />
      <Route exact path="/trading/shipment/remind" component={props => <ShipmentRemind {...props} />} />
      <Route exact path="/trading/gift" component={props => <Gift {...props} />} />
      <Route
        exact
        path="/trading/pay-code/search/:errorId?/:pay_code?"
        component={props => <PaycodeSearch {...props} />}
      />
      <Route exact path="/trading/pay-code/refund-list" component={props => <PayCodeRefundList {...props} />} />
      <Route exact path="/trading/pay-error/lists" component={props => <PayErrorList {...props} />} />
      <Route exact path="/trading/refund-freight" component={props => <RefundFreight {...props} />} />
      <Route exact path="/trading/refund-error" component={props => <RefundError {...props} />} />

      {/* 促销 */}
      <Route exact path="/promotion/seckill" component={props => <Seckill {...props} />} />
      <Route exact path="/promotion/seckill/:type/:seckillId" component={props => <SeckillDetails {...props} />} />
      <Route exact path="/promotion/logistics-cover" component={props => <LogisticsCover {...props} />} />
      <Route exact path="/promotion/logistics-cover/edit/:id?" component={props => <LogisticsCoverEdit {...props} />} />
      <Route exact path="/promotion/general-h5" component={props => <GeneralHtml {...props} />} />
      <Route exact path="/promotion/general-h5/edit/:id?" component={props => <GeneralHtmlEdit {...props} />} />
      <Route exact path="/promotion/relay" component={props => <Relay {...props} />} />

      {/* 运营 */}
      <Route exact path="/operation/message" component={props => <Message {...props} />} />
      <Route exact path="/operation/docment" component={props => <Docment {...props} />} />
      <Route exact path="/operation/invite" component={props => <Invite {...props} />} />
      <Route exact path="/operation/lottery" component={props => <Lottery {...props} />} />
      <Route exact path="/operation/goods/setting" component={props => <GoodsSetting {...props} />} />
      <Route exact path="/operation/support/complain" component={props => <SupportComplain {...props} />} />
      <Route exact path="/operation/support/feedback" component={props => <SupportFeedback {...props} />} />
      <Route exact path="/operation/payment" component={props => <Payment {...props} />} />
      <Route exact path="/operation/payment/:id" component={props => <PaymentAccountList {...props} />} />
      <Route exact path="/operation/refund/coupon" component={props => <RefundCoupon {...props} />} />
      <Route exact path="/operation/ads/:ap_id?" component={props => <Ads {...props} />} />
      <Route exact path="/operation/ads-edit/:adv_id?" component={props => <AdsEdit {...props} />} />
      <Route exact path="/operation/ads-area" component={props => <AdsArea {...props} />} />
      <Route exact path="/operation/ads-position" component={props => <AdsPosition {...props} />} />
      <Route exact path="/operation/skip-ads-type" component={props => <AdsSkip {...props} />} />
      <Route
        exact
        path="/operation/ads-position-edit/:id?/:type?"
        component={props => <AdsPositionEdit {...props} />}
      />
      <Route exact path="/operation/posters" component={props => <AdsPosters {...props} />} />
      <Route exact path="/operation/coupons" component={props => <Coupons {...props} />} />
      <Route exact path="/operation/coupons/create" component={props => <CouponsCreate {...props} />} />
      <Route exact path="/operation/complain-feedback-list" component={props => <ComplainFeedBackList {...props} />} />
      <Route exact path="/operation/gift-activity" component={props => <GiftActivity {...props} />} />
      <Route exact path="/operation/gift-activity/save/:id?" component={props => <GiftActivitySave {...props} />} />
      <Route exact path="/operation/exchange-activity" component={props => <ExchangeActivity {...props} />} />
      <Route
        exact
        path="/operation/exchange-activity/save/:id?/:is_show?"
        component={props => <ExchangeActivitySave {...props} />}
      />
      <Route exact path="/operation/skins" component={props => <Skins {...props} />} />
      <Route
        exact
        path="/operation/skins/save/:client/:skin_id?/:is_show?"
        component={props => <SkinsSave {...props} />}
      />
      <Route exact path="/operation/delay-shipment" component={props => <DelayShipment {...props} />} />
      <Route exact path="/operation/delay-shipment/edit/:id?" component={props => <DelayShipmentEdit {...props} />} />

      {/* 社区 */}
      <Route exact path="/community/comments" component={props => <Comments {...props} />} />
      <Route exact path="/community/white-list" component={props => <CommunityWhiteList {...props} />} />
      <Route exact path="/community/posts" component={props => <Posts {...props} />} />
      <Route exact path="/community/level" component={props => <CommunityLevel {...props} />} />
      <Route exact path="/community/users" component={props => <CommunityUsers {...props} />} />
      <Route exact path="/community/posts/edit/:post_id?" component={props => <PostsEdit {...props} />} />
      <Route
        exact
        path="/community/posts/edit-official/:post_id?"
        component={props => <PostsOfficialEdit {...props} />}
      />

      {/* 系统 */}
      <Route exact path="/system/purview" component={props => <Purview {...props} />} />
      <Route exact path="/system/organization" component={props => <Organization {...props} />} />
      <Route exact path="/system/user-roles" component={props => <UserRoles {...props} />} />
      <Route exact path="/system/workers" component={props => <Workers {...props} />} />
      <Route exact path="/system/logs" component={props => <SystemLogs {...props} />} />
      <Route exact path="/system/user-roles/edit/:id?" component={props => <UserRolesEdit {...props} />} />
      <Route exact path="/system/app-versions" component={props => <AppVersions {...props} />} />
      <Route exact path="/system/app-version-new" component={props => <AppVersionNew {...props} />} />
      <Route exact path="/system/gray-test" component={props => <GrayTask {...props} />} />
      <Route exact path="/system/redis-search" component={props => <Redis {...props} />} />
      <Route exact path="/system/redis-pay" component={props => <RedisPay {...props} />} />
      <Route exact path="/system/redis-panel" component={props => <RedisPanel {...props} />} />
      <Route exact path="/system/redis-cart" component={props => <RedisCart {...props} />} />
      <Route exact path="/system/redis-cart-panel" component={props => <RedisCartPanel {...props} />} />
      <Route exact path="/system/redis-cache" component={props => <RedisCache {...props} />} />
      <Route exact path="/system/redis-cache-panel" component={props => <RedisCachePanel {...props} />} />
      <Route exact path="/system/cache-search/:cache_key?" component={props => <CacheSearch {...props} />} />
      <Route exact path="/system/payment/tree" component={props => <PaymentTree {...props} />} />

      {/* 工单 */}
      <Route exact path="/working-orders/lists" component={props => <WorkingOrderList {...props} />} />
      <Route exact path="/working-orders/config" component={props => <WorkingOrderConfig {...props} />} />
      <Route exact path="/working-orders/detail/:id" component={props => <WorkingOrderDetail {...props} />} />

      {/* 统计 */}
      <Route exact path="/statistic/data-agent" component={props => <AgentData {...props} />} />
      <Route exact path="/statistic/top-goods" component={props => <TopGoods {...props} />} />
      <Route exact path="/statistic/data-integral" component={props => <Integral {...props} />} />
      <Route exact path="/statistic/seckill" component={props => <StatisticSeckill {...props} />} />
      <Route exact path="/statistic/data-timeout" component={props => <OrdersTimeOut {...props} />} />
      <Route exact path="/statistic/finance" component={props => <Finance {...props} />} />
      <Route
        exact
        path="/statistic/financial-reconciliation"
        component={props => <FinancialReconciliation {...props} />}
      />
      <Route exact path="/statistic/yun-ji" component={props => <YunJi {...props} />} />
      <Route exact path="/statistic/data-refund" component={props => <StatisticRefund {...props} />} />
      <Route exact path="/statistic/daily-new" component={props => <DailyNew {...props} />} />

      {/* 官网 */}
      <Route exact path="/website/news" component={props => <WebNews {...props} />} />
      <Route exact path="/website/news/save/:id?" component={props => <WebNewsSave {...props} />} />
      <Route exact path="/website/appliers" component={props => <Appliers {...props} />} />
      <Route exact path="/website/basic-setting" component={props => <BasicSetting {...props} />} />

      {/* 基本 */}
      <Route exact path="/basic/express" component={props => <BasicExpress {...props} />} />
      <Route exact path="/basic/keywords" component={props => <Keywords {...props} />} />
      <Route exact path="/basic/banks" component={props => <Banks {...props} />} />
      <Route exact path="/basic/account" component={props => <Account {...props} />} />
      <Route exact path="/basic/paying" component={props => <Paying {...props} />} />
      <Route exact path="/basic/setting" component={props => <Setting {...props} />} />
      <Route exact path="/basic/setting/json-edit/:id?" component={props => <SettingEdit {...props} />} />
      <Route exact path="/basic/setting/u-edit/:id?" component={props => <SettingUEdit {...props} />} />

      {/* 买手 */}
      <Route exact path="/buyers/management" component={props => <Buyers {...props} />} />
      <Route exact path="/buyers/grade/:tabIndex?/:buy_id?" component={props => <BuyersGrade {...props} />} />

      {/* 预约 */}
      <Route exact path="/appointment/waiting" component={props => <AppointmentWait {...props} />} />
      <Route exact path="/appointment/list" component={props => <AppointmentList {...props} />} />
      <Route exact path="/appointment/config" component={props => <AppointmentConfig {...props} />} />
      <Route exact path="/appointment/config-edit/:aa_id?" component={props => <AppointmentConfigEdit {...props} />} />

      {/* 区域邀请 */}
      <Route
        exact
        path="/district-invite/error-monitor"
        component={props => <DistrictInviteErrorMonitor {...props} />}
      />
      <Route
        exact
        path="/district-invite/invite-rules-all"
        component={props => <DistrictInviteRulesAll {...props} />}
      />
      <Route exact path="/district-invite/invite-rules" component={props => <DistrictInviteRules {...props} />} />

      {/* KA */}
      <Route exact path="/ka/ka-buyers/:shop_id?" component={props => <KaBuyers {...props} />} />
      <Route exact path="/ka/year-manifest" component={props => <KaYearManifest {...props} />} />
      <Route exact path="/ka/logs" component={props => <KaLogs {...props} />} />
      <Route exact path="/ka/config" component={props => <KaConfig {...props} />} />

      {/* 供应商 */}
      <Route exact path="/supplier/list" component={props => <SupplierList {...props} />} />
      <Route exact path="/supplier/goods/:id" component={props => <SupplierGoods {...props} />} />
      <Route exact path="/supplier/entity-list" component={props => <SupplierEntityList {...props} />} />

      {/* 连连 */}
      <Route exact path="/lianlian/withdraw-list" component={props => <LianlianWithdrawList {...props} />} />
      <Route exact path="/lianlian/account-list" component={props => <LianlianAccountList {...props} />} />
      <Route exact path="/lianlian/enterprise-list" component={props => <LianlianEnterpriseList {...props} />} />

      {/* 支付宝批量打款 */}
      <Route exact path="/alipay-remit/list" component={props => <AlipayRemitList {...props} />} />
      <Route exact path="/alipay-remit/create" component={props => <AlipayRemitCreate {...props} />} />

      {/* 重定向 */}
      <Redirect from="/*" to="/not-found" />
    </Switch>
  );
};

export default Distributor;
